import { Form } from '@unform/web'
import { t } from 'i18next'

import { AlertWithTitle } from '~/components/AlertWithTitle'
import { Button } from '~/components/Buttons'
import { FormGroup, Label, Textarea } from '~/components/unform'

import * as S from './styles'

interface Props {
  contentModal: ContentModal
  /** O mesmo que `useModal` devolve; sem os props, nada aqui era checado. */
  Modal: React.FC<ModalProps>
  showConfirmationModal: boolean
  toggleConfirmationModal(): void
  /**
   * Trava o envio enquanto a decisão está em trânsito. Sem isso, o modal segue
   * aberto e clicável durante a requisição, e dois cliques viram duas
   * decisões concorrentes. Opcional porque os consumidores mais antigos não
   * têm estado de envio para informar.
   */
  isSubmitting?: boolean
  handleSubmit: ({
    dataForm,
    status
  }: {
    dataForm: FormData
    status: CampaignStatus
    action: CampaignActions
  }) => void
}

export const ModalConfirmations = ({
  Modal,
  showConfirmationModal,
  toggleConfirmationModal,
  contentModal,
  handleSubmit,
  isSubmitting = false
}: Props) => {
  return (
    <Modal
      title={contentModal?.titleModal}
      isOpen={showConfirmationModal}
      onClose={toggleConfirmationModal}
    >
      {!!contentModal?.alertMessage && (
        <S.WrapperAlert>
          <AlertWithTitle
            title={contentModal?.titleAlertMessage}
            description={contentModal?.alertMessage}
            variant={contentModal?.alertVariant || 'critical'}
          />
        </S.WrapperAlert>
      )}
      <S.Container>
        <Form
          onSubmit={dataForm =>
            handleSubmit({
              note: contentModal?.note,
              ...dataForm,
              status: contentModal?.status,
              action: contentModal?.action
            })
          }
        >
          <FormGroup>
            {!!contentModal?.labelMessage && (
              <Label htmlFor="note" isRequired={contentModal?.noteIsRequired}>
                {contentModal?.labelMessage}
              </Label>
            )}
            {!!contentModal?.subtitletLabelMessage && (
              <small> {contentModal?.subtitletLabelMessage}</small>
            )}
            {!!contentModal?.labelMessage && (
              <Textarea
                name="note"
                minHeight="4px"
                required={contentModal?.noteIsRequired}
                maxLength={contentModal?.noteMaxLength}
                showLength={!!contentModal?.noteMaxLength}
              />
            )}
          </FormGroup>

          <S.WrapperButtons hasCancelButton={contentModal?.hasCancelButton}>
            {contentModal?.hasCancelButton && (
              <Button template="transparent" onClick={toggleConfirmationModal}>
                Cancelar
              </Button>
            )}
            <Button
              template={contentModal?.templateButton || 'primary'}
              customWidth={!contentModal?.hasCancelButton ? '100%' : '0'}
              type="submit"
              loading={isSubmitting}
            >
              {contentModal?.textButton || t('rm:Continue')}
            </Button>
          </S.WrapperButtons>
        </Form>
      </S.Container>
    </Modal>
  )
}
